import { render, staticRenderFns } from "./BgMusicComponent.vue?vue&type=template&id=6c214e62&scoped=true&"
import script from "./BgMusicComponent.vue?vue&type=script&lang=js&"
export * from "./BgMusicComponent.vue?vue&type=script&lang=js&"
import style0 from "./BgMusicComponent.vue?vue&type=style&index=0&id=6c214e62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c214e62",
  null
  
)

export default component.exports